/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DashboardControllerDtoGetDashboardDataTransactionStatistics model module.
 * @module model/DashboardControllerDtoGetDashboardDataTransactionStatistics
 * @version 1.0
 */
class DashboardControllerDtoGetDashboardDataTransactionStatistics {
    /**
     * Constructs a new <code>DashboardControllerDtoGetDashboardDataTransactionStatistics</code>.
     * @alias module:model/DashboardControllerDtoGetDashboardDataTransactionStatistics
     */
    constructor() { 
        
        DashboardControllerDtoGetDashboardDataTransactionStatistics.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DashboardControllerDtoGetDashboardDataTransactionStatistics</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DashboardControllerDtoGetDashboardDataTransactionStatistics} obj Optional instance to populate.
     * @return {module:model/DashboardControllerDtoGetDashboardDataTransactionStatistics} The populated <code>DashboardControllerDtoGetDashboardDataTransactionStatistics</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardControllerDtoGetDashboardDataTransactionStatistics();

            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Date');
            }
            if (data.hasOwnProperty('tradingNft')) {
                obj['tradingNft'] = ApiClient.convertToType(data['tradingNft'], 'Number');
            }
            if (data.hasOwnProperty('tradingNftBox')) {
                obj['tradingNftBox'] = ApiClient.convertToType(data['tradingNftBox'], 'Number');
            }
            if (data.hasOwnProperty('tradingGem')) {
                obj['tradingGem'] = ApiClient.convertToType(data['tradingGem'], 'Number');
            }
            if (data.hasOwnProperty('tradingItem')) {
                obj['tradingItem'] = ApiClient.convertToType(data['tradingItem'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DashboardControllerDtoGetDashboardDataTransactionStatistics</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DashboardControllerDtoGetDashboardDataTransactionStatistics</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} timestamp
 */
DashboardControllerDtoGetDashboardDataTransactionStatistics.prototype['timestamp'] = undefined;

/**
 * @member {Number} tradingNft
 */
DashboardControllerDtoGetDashboardDataTransactionStatistics.prototype['tradingNft'] = undefined;

/**
 * @member {Number} tradingNftBox
 */
DashboardControllerDtoGetDashboardDataTransactionStatistics.prototype['tradingNftBox'] = undefined;

/**
 * @member {Number} tradingGem
 */
DashboardControllerDtoGetDashboardDataTransactionStatistics.prototype['tradingGem'] = undefined;

/**
 * @member {Number} tradingItem
 */
DashboardControllerDtoGetDashboardDataTransactionStatistics.prototype['tradingItem'] = undefined;






export default DashboardControllerDtoGetDashboardDataTransactionStatistics;

